import { EYE_TRACKING_ERRORS } from './EyeTrackingClient.constants';
const DEFAULT_EXTENSION_ID = 'capmlbfmakkjjmdanjgjenihdaohjdcj';
/**
 * EyeTrackingClient allows to connect to eye-tracking extensions from DM Team.
 * @class
 */
class EyeTrackingClient {
    options;
    port;
    onSuccess = null;
    onError = null;
    onMessage = null;
    constructor(options = {}) {
        this.options = options;
    }
    /**
     * Connect to extension.
     *
     * @method
     * @name EyeTrackingClient#connect
     */
    connect() {
        try {
            if (!chrome?.runtime?.connect) {
                this.onError?.(new Error(EYE_TRACKING_ERRORS.NotSupported));
                return;
            }
            this.port = chrome.runtime.connect(this.options?.id ?? DEFAULT_EXTENSION_ID, { name: 'dalsWebStereo' });
            this.port.onMessage.addListener((msg) => this.onMessage?.(msg));
            this.onSuccess?.();
        }
        catch (e) {
            this.onError?.(e);
        }
    }
    /**
     * Send message to extension.
     *
     * @method
     * @name EyeTrackingClient#sendMessage
     * @param {string} message Message.
     */
    sendMessage(message) {
        this.port?.postMessage?.(message);
    }
    /**
     * Disconnect from extension.
     *
     * @method
     * @name EyeTrackingClient#disconnect
     */
    disconnect() {
        this.port?.disconnect?.();
    }
}
export { EyeTrackingClient };
